import React from 'react';

import {
  Typography,
  Grid,
} from '@material-ui/core';

import { SHAADIYOG_HOST } from '../../config/constants';
import { getKakaImageDynamic } from '../../util';


const getContent1 = (content = 'anjal') => {
  if (content === 'sy') {
    return (
      <Typography variant="subheading">
        {'Name - Late Shri Bhawanishankarji Khemka'}<br />
        {'Description - (28th April 1945 - 17th August 2009)'}
        <br /><br />
        {'Spent his childhood in Rangoon then shifted to Rantangarh, Rajasthan.'}
        {'His father Late Shri Dharamchandji Khemka left for his heavenly abode when Late Shri Bhawanishankarji Khemka had to take the responsibility and start the work of intracity trading at 11 years of age. He always had an attitude of "Never say die and keep working".'}
      </Typography>
    );
  }
  return (
    <Typography variant="subheading">
      {'Late Shri Ratibhai Sodha ( Mr. Jayendrabhai\'s Father) wished to help Lohana community families seeking suitable match for their sons/daughters started assisting them with matrimonial information of prospective candidates of other similar families.'}
      <br /><br />
      {'These matrimonial services has been continued by Mr. Jayendra Sodha with immense joy & pleasure and same objectives to provide ultimate partner search experience and serve the community by connecting most suitable like minded Brides & Grooms and set happiness in society. Thus the seeds of this "Anjal ane Avasar" - Jayendra Sodha Lohana/ gujarati Vaishnav community Free matrimonial information Center were planted by Late shri Ratibhai Sodha about 30 years ago.'}
    </Typography>
  );
};


const getContent2 = (content = 'anjal') => {
  if (content === 'sy') {
    return (
      <React.Fragment>
        <Typography variant="subheading">
          {'Before settling in Mumbai in 1971, he did several businesses. He always had a keen interetest towards social service and working towards the betterment of the Marwari community.'}
        </Typography>
        <Typography variant="subheading" style={{ marginTop: '10px' }}>
          {'He gave us the slogan "Don\'t worry about the problem, find a solution and keep going". We all at Khemka family are excelling following principles and values he laid down on us. His blessings are always there with us...'}
        </Typography>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <Typography variant="subheading">
        {'Today Ours, is the largest and most trusted matrimonial information center, services for the community with senior advisory team comprising of all business class busy persons devoting their time and efforts to assist prospective candidates in search for a true life partner.'}
      </Typography>
      <ul>
        <li>
          <Typography variant="subheading">
              We accept forms/Registration only from Lohana & Gujarati Vaishnav Community People.
          </Typography>
        </li>
        <li>
          <Typography variant="subheading">
            {'We do not accept Registration of any candidate without a reference of any known person to us.'}
          </Typography>
        </li>
        <li>
          <Typography variant="subheading">
              Acceptance of all forms are subject to approvals by Mr . Jayendra Sodha .
          </Typography>
        </li>
        <li>
          <Typography variant="subheading">
            {'All candidates have to personally visit and meet Mr Jayendra Sodha at our Santacruz east, Mumbai center on any Sunday with parents and submit their   Registration form between 10 Am & 2 Pm.'}
          </Typography>
        </li>
        <li>
          <Typography variant="subheading">
            {'Registration Form can be rejected if any crucial or important information of the candidate desiring to marry is not disclosed to Mr jayendra Sodha.'}
          </Typography>
        </li>
      </ul>
    </React.Fragment>
  );
};


const aboutUs = () => {
  return (
    <React.Fragment>
      {window.location.host === SHAADIYOG_HOST && (
      <Grid container spacing={8}>
        <Grid item md={2}>
          <img alt="about" src={getKakaImageDynamic('sy')} style={{ width: '100%', border: 'thin solid #666' }} />
        </Grid>
        <Grid item md={10}>
          {getContent1('sy')}
        </Grid>
        <Grid item md={12}>
          {getContent2('sy')}
        </Grid>
      </Grid>
      )}
      {window.location.host === SHAADIYOG_HOST && (
        <React.Fragment>
          <br />
          <Typography variant="headline">
        About Anjal ane Avsar
          </Typography>
          <br />
        </React.Fragment>
      )}
      <Grid container spacing={8}>
        <Grid item md={2}>
          <img alt="about" src={getKakaImageDynamic()} style={{ width: '100%', border: 'thin solid #666' }} />
        </Grid>
        <Grid item md={10}>
          {getContent1()}
        </Grid>
        <Grid item md={12}>
          {getContent2()}
        </Grid>
      </Grid>
      <Grid container spacing={8}>
        <Grid item md={12}>
          <Typography variant="subheading">
            Disclaimer: <br />
            {'Marriages are made in heaven and we are just trying our best to bring couple in a very pious relationship. We do not accept any obligations or responsibilities and we do not charge any amount at any point of time and do not accept any compensation/gift directly or indirectly from any candidate or their family. It is just a social honorary service.'}
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};


export default aboutUs;



// WEBPACK FOOTER //
// ./src/main/components/AboutUs.js